<vb-panel-header
    title="My appointments"
    [subtitle]="totalCount + ' appointment' + (totalCount === 1 ? '' : 's')">
</vb-panel-header>

<vb-paginator-bar
    *ngIf="!isLoading && rows.length > 0"
    class="appt-panel__topbar"
    variant="top"
    label="appointments"
    [dense]="isMobile"
    [current]="paginate.currentPage || 1"
    [total]="paginate.totalPages || 0"
    [totalItems]="paginate.totalItems || 0"
    [perPage]="pageSize"
    [perPageOptions]="pageSizeOptions"
    (pageChange)="setPage($event)"
    (perPageChange)="setPageSize($event)">
</vb-paginator-bar>

<vb-appointment-table
    *ngIf="!isLoading && rows.length > 0"
    class="appt-panel__table"
    [rows]="rows"
    (cancelAppointment)="onCancelAppointment($event)"
    (invoiceOpen)="onInvoiceOpen($event)">
</vb-appointment-table>

<div *ngIf="!isLoading && rows.length === 0" class="appt-panel__empty">
    No data to show at the moment.
</div>

<div *ngIf="isLoading" class="appt-panel__loading">
    <vb-spinner size="l" label="Loading your appointments"></vb-spinner>
</div>

<footer class="appt-panel__footer" *ngIf="!isLoading && rows.length > 0">
    <vb-legend [items]="legendItems"></vb-legend>
    <vb-paginator
        [current]="paginate.currentPage || 1"
        [total]="paginate.totalPages || 0"
        [labels]="false"
        [dense]="isMobile"
        (pageChange)="setPage($event)">
    </vb-paginator>
</footer>
